import { ThemeEvents, VariantUpdateEvent } from "@theme/events";

/**
 * A custom element that displays a product RRP (Recommended Retail Price).
 * This component listens for variant update events and updates the RRP display accordingly.
 */
class ProductRrp extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest(".shopify-section, dialog");
    if (!closestSection) return;
    closestSection.addEventListener(
      ThemeEvents.variantUpdate,
      this.updateRrp
    );
  }

  disconnectedCallback() {
    const closestSection = this.closest(".shopify-section, dialog");
    if (!closestSection) return;
    closestSection.removeEventListener(
      ThemeEvents.variantUpdate,
      this.updateRrp
    );
  }

  /**
   * Updates the RRP.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateRrp = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    // Query for the product-rrp element that matches this instance's product ID
    const productId = this.dataset.productId;
    const newProductRrp = event.detail.data.html.querySelector(
      `product-rrp[data-product-id="${productId}"]`
    );

    if (!newProductRrp) return;

    const newRrp = newProductRrp.querySelector('[ref="rrpContainer"]');
    const currentRrp = this.querySelector('[ref="rrpContainer"]');

    if (!newRrp || !currentRrp) return;

    if (currentRrp.innerHTML !== newRrp.innerHTML) {
      currentRrp.replaceWith(newRrp);
    }
  };
}

if (!customElements.get("product-rrp")) {
  customElements.define("product-rrp", ProductRrp);
}

